import { REDUCERS } from '../../constants/reducers';

const initialState = {
  events: [],
  queryParams: {},
  currentEvent: {
    title: '',
    description: '',
    startDate: '',
    endDate: '',
    remindDate: '',
    relationId: '',
    relationType: '',
    recurringEndDate: '',
    recurringType: '',
    userIds: [],
    userEmails: [],
    relations: []
  },
  filteredEvents: [],
  eventsForNextThreeDays: []
};

const event = (state = initialState, action) => {
  switch (action.type) {
    case REDUCERS.EVENT.SET_EVENT_STATE: {
      return Object.assign({}, state, {
        ...state,
        ...action.value
      });
    }
    case REDUCERS.EVENT.SET_EVENT_QUERY_PARAMS: {
      return Object.assign({}, state, {
        queryParams: { ...action.value }
      });
    }
    case REDUCERS.EVENT.SET_EVENT_LIST: {
      return Object.assign({}, state, {
        events: [...action.value],
        filteredEvents: [...action.value]
      });
    }
    case REDUCERS.EVENT.SET_EVENTS_FOR_NEXT_THREE_DAYS: {
      return Object.assign({}, state, {
        eventsForNextThreeDays: [...action.value]
      });
    }
    case REDUCERS.EVENT.SET_FILTERED_EVENTS: {
      return Object.assign({}, state, {
        filteredEvents: [...action.value]
      });
    }
    case REDUCERS.EVENT.SET_CURRENT_EVENT: {
      return Object.assign({}, state, {
        currentEvent: { ...state.currentEvent, ...action.value }
      });
    }
    case REDUCERS.RESET:
      return initialState;
    default:
      return state;
  }
};

export { event };
